import styled from '@emotion/styled'
import { motion } from 'framer-motion'
import { useCallback, useEffect, useRef, useState } from 'react'
import { useRecoilState } from 'recoil'

import audioImg from '@/assets/images/audio.png'
import courseRightImg from '@/assets/images/course_right.png'
import ImgPlaceholder from '@/components/ImgPlaceholder'
import { roomEvent, rtmClient } from '@/pages/room'
import { CoursewareList, GameCourseware } from '@/store/courseware'
import { bigWinState, restState } from '@/store/room'
import { sleep } from '@/utils/tool'

interface IProps {
  course: CoursewareList
  autoplay: boolean
}

export default function Index({ course, autoplay }: IProps) {
  const { json, coverUrl, picUrl } = course
  const {
    // 错误音效
    errorAudiosWeb,
    // 题干 type=1时是文字题干 type=2时是图片题干
    subjectWeb,
    // 背景
    backgroundWeb,
    // 题干的类型 1 文字 2 图片（注意是字符串类型）
    type,
    // 正确答案与items中的ID匹配
    result,
    // 正确音效
    rightAudiosWeb,
    // 题干的音乐
    soundWeb,
    // 选项
    items = []
  } = json as GameCourseware
  const [audioIndex, setAudioIndex] = useState(0)
  const [palySound, setPalySound] = useState(false)
  const [selectResult, setSelectResult] = useState({ state: 0, id: 0 })
  const selectErrorTimeRef = useRef<any>(null)
  const palySoundTimeRef = useRef<any>(null)
  const palySoundRef = useRef<HTMLAudioElement>(null)
  const errorAudioRef = useRef<HTMLAudioElement>(null)
  const rightAudioRef = useRef<HTMLAudioElement>(null)
  const [bigWin, setBigWin] = useRecoilState(bigWinState)
  const [rest, setRest] = useRecoilState(restState)

  useEffect(() => {
    firstPlay()
    return () => {
      // 如果两个互动课件互相切换，会存在数据更新，dom与audio未更新，所以需要在更新course设置palySound=false
      setPalySound(false)
    }
  }, [course])

  const firstPlay = async () => {
    // 由于默认进到互动课件需要播放题干音乐，所以设置palySound=true，避免与上一个更新course设置false被useState合并处理导致useEffect不能准确执行，需要延时100
    await sleep(100)
    autoplay && setPalySound(true)
    setSelectResult({ state: 0, id: 0 })
  }

  useEffect(() => {
    // 播放完成后设置题干音频状态为关闭
    if (palySoundRef.current) {
      palySoundRef.current.onended = () => {
        setPalySound(false)
      }
    }
    return () => {
      selectErrorTimeRef.current && clearTimeout(selectErrorTimeRef.current)
    }
  }, [])

  useEffect(() => {
    // rtmClient.on('ArtCourseChoose', artCourseChoose)
    return () => {
      // rtmClient.removeListener('ArtCourseChoose', artCourseChoose)
    }
  }, [selectResult, result])

  // const artCourseChoose = useCallback(
  //   (memberId: string, payload: any) => {
  //     const { chooseNum } = payload
  //     select(chooseNum)
  //   },
  //   [selectResult, result]
  // )

  // 监听题干音频状态，播放题干音频
  useEffect(() => {
    setAudioIndex(0)
    palySoundRef.current?.pause()
    if (palySound && palySoundRef.current) {
      palySoundRef.current.currentTime = 0
      palySoundRef.current.play()
      playSoundAudio()
    }
    return () => {
      palySoundTimeRef.current && clearInterval(palySoundTimeRef.current)
    }
  }, [palySound])

  // 播放图标动画
  const playSoundAudio = () => {
    palySoundTimeRef.current = setTimeout(() => {
      if (palySound) {
        setAudioIndex((v) => (v < 2 ? v + 1 : 0))
        playSoundAudio()
      }
    }, 500)
  }

  // 选择答案
  const select = (id: number) => {
    if (selectResult.state) return
    selectErrorTimeRef.current && clearTimeout(selectErrorTimeRef.current)
    if (id !== result) {
      rtmClient.sendMessage('ArtCourseChoose', {
        chooseResult: false,
        chooseNum: id
      })
      if (errorAudioRef.current) {
        errorAudioRef.current.currentTime = 0
        errorAudioRef.current.play()
      }
      setSelectResult({ state: 0, id })
      selectErrorTimeRef.current = setTimeout(() => {
        setSelectResult({ state: 0, id: 0 })
      }, 1000)
    } else {
      rtmClient.sendMessage('ArtCourseChoose', {
        chooseResult: true,
        chooseNum: id
      })
      rightAudioRef.current?.play()
      setSelectResult({ state: 1, id })
      roomEvent.emit('lottie', 'courseRight')
    }
  }

  return (
    <Container className={`w-full h-full`}>
      <GameBox url={backgroundWeb} className={`w-full h-full flex flex-col justify-center items-center ${bigWin !== 1 ? 'hidden' : ''}`}>
        <div className="w-full h-[40%] flex justify-center items-center">
          <div className="w-[40%] rounded-[1.2vh] shadow-glass relative bg-white overflow-hidden">
            {type === '1' ? <div className="p-[2.16vh] ml-[5.54vh]">{subjectWeb}</div> : null}
            {type === '2' ? <ImgPlaceholder className="object-cover" src={subjectWeb} /> : null}
            <div
              onClick={() => {
                if (rest.state !== 1) {
                  setPalySound(true)
                }
              }}
              className="bg-[#FAA226] rounded-[1.2vh] w-[4.8vh] h-[4.8vh] absolute top-[1.2vh] left-[1.2vh] anim_btn2 flex justify-center items-center"
            >
              <AudioImg url={audioImg} audioIndex={audioIndex} className="w-[3.6vh] h-[3.6vh]"></AudioImg>
              <audio ref={palySoundRef}>
                <source src={soundWeb} type="audio/mp3" />
              </audio>
            </div>
          </div>
        </div>
        {/* 这里是选项的布局 选项为2/3/4个，flex布局对3个选项单独处理，2/4个flex-wrap */}
        <div className={`w-[50%] flex-1 flex justify-center gap-[3.6vh] ${items.length === 3 ? 'flex-wrap-reverse flex-row-reverse content-end' : 'flex-wrap content-start'}`}>
          {(items.length === 3 ? [...items].reverse() : items).map((v) => (
            <div
              key={v.id}
              onClick={() => select(v.id)}
              className={`relative shadow-glass ${
                selectResult.id === v.id ? (!selectResult.state ? 'animate__shakeX' : ' shadow-right') : ''
              } w-[40%] h-[30%] bg-white rounded-[1.2vh] overflow-hidden`}
            >
              <ImgPlaceholder className="w-full h-full object-contain" src={v.imageWeb} />
              {selectResult.id === v.id && selectResult.state ? <img className="absolute top-[1.2vh] right-[1.2vh] w-[3.6vh] h-[3.6vh]" src={courseRightImg} /> : null}
            </div>
          ))}
        </div>
      </GameBox>
      {bigWin !== 1 ? (
        <div className="w-full h-full flex justify-center items-center">
          <ImgPlaceholder className="w-full h-full object-contain cursor-pointer" src={coverUrl || picUrl} />
        </div>
      ) : null}
      {/* errorAudiosWeb 错误音效 */}
      <audio ref={errorAudioRef}>
        <source src={errorAudiosWeb[0]} type="audio/mp3" />
      </audio>
      {/* rightAudiosWeb 正确音效 */}
      <audio ref={rightAudioRef}>
        <source src={rightAudiosWeb[0]} type="audio/mp3" />
      </audio>
    </Container>
  )
}

const Container = styled(motion.div)``

const GameBox = styled(motion.div)<{ url: string }>`
  background: url(${(props) => props.url});
  background-position: center;
  background-repeat: no-repeat;
`

const AudioImg = styled(motion.div)<{ url: string; audioIndex: number }>`
  background: url(${(props) => props.url});
  background-size: auto 3vh;
  background-position: ${(props) => [-7.22, -3.61, 0][props.audioIndex]}vh 0.48vh;
  background-repeat: no-repeat;
`
